import Description from '@picsart/growth-rc/Description';
import cls from 'classnames';
import { TitleWithDescriptionProps } from './types';

import TitleWithDefaultSize from '../TitleWithDefaultSize';
import useStyles from './styles';
import CenteredContainer from '../CenteredContainer';

function TitleWithDescription({ className, title, description }: TitleWithDescriptionProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, className)}>
      <CenteredContainer>
        <TitleWithDefaultSize title={title} />
        <Description {...description} className={classes.description} />
      </CenteredContainer>
    </div>
  );
}

export default TitleWithDescription;
